import Vue from 'vue';
import { GLOBAL_ERROR } from '@/utils/constants';
import { getSettlement as getSettlementCall } from '../../api/settlement';

export async function getSettlement({ commit, dispatch }, quoteId) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['settlementLoading', true]);
      let settlement = await getSettlementCall(quoteId);
      if (settlement) {
        commit('setSettlement', settlement);
      }
      commit('setState', ['settlementLoading', false]);
      return resolve();
    } catch (err) {
      commit('setState', ['settlementLoading', false]);
      // eslint-disable-next-line
      console.error(err);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR,
        action: () => dispatch('getSettlement')
      });
      return reject();
    }
  });
}
